module.exports = __webpack_public_path__ + "static/img/money.6f594c12.png";